export const THEME_STORAGE_KEY = 'lighthouse-theme';
function getStorage() {
    try {
        const storage = globalThis.localStorage;
        return storage ?? null;
    }
    catch {
        return null;
    }
}
function getRootElement() {
    try {
        const doc = globalThis.document;
        return doc?.documentElement ?? null;
    }
    catch {
        return null;
    }
}
export function getStoredTheme() {
    const storage = getStorage();
    if (!storage)
        return 'light';
    try {
        return storage.getItem(THEME_STORAGE_KEY) === 'dark' ? 'dark' : 'light';
    }
    catch {
        return 'light';
    }
}
export function applyTheme(mode) {
    const root = getRootElement();
    if (!root)
        return;
    if (mode === 'dark') {
        root.classList.add('dark');
    }
    else {
        root.classList.remove('dark');
    }
    root.style.colorScheme = mode;
}
export function setStoredTheme(mode) {
    const storage = getStorage();
    try {
        storage?.setItem(THEME_STORAGE_KEY, mode);
    }
    catch {
        /* ignore quota / private mode */
    }
    applyTheme(mode);
}
export function initTheme() {
    const mode = getStoredTheme();
    applyTheme(mode);
    return mode;
}
export function toggleTheme(current) {
    const next = current === 'light' ? 'dark' : 'light';
    setStoredTheme(next);
    return next;
}
/** Inline in index.html — prevents flash before React loads */
export const THEME_INIT_SCRIPT = `(function(){try{var t=localStorage.getItem('${THEME_STORAGE_KEY}');if(t==='dark'){document.documentElement.classList.add('dark');document.documentElement.style.colorScheme='dark';}else{document.documentElement.style.colorScheme='light';}}catch(e){}})();`;
//# sourceMappingURL=theme.js.map